module.exports = {"event_message":"Register Soon! ","event_expiry":"This Event Expires ","event_expiry_mobile":"Event Expires "}